import React, { useRef, useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import tentang2 from './Asset/tentang-2.webp';
import tentang3 from './Asset/tentang-3.webp';
import tentang4 from './Asset/tentang-4.webp';
import tentang5 from './Asset/tentang-5.webp';
import tentang6 from './Asset/tentang-6.webp';
import tentang7 from './Asset/tentang-7.webp';
import tentang8 from './Asset/tentang-8.webp';
import tentang9 from './Asset/tentang-9.webp';
import tentang10 from './Asset/tentang-10.webp';
import tentang11 from './Asset/tentang-11.webp';
import { Helmet } from 'react-helmet-async';
import { useCallback } from 'react';

function TentangBYD() {
  const sections = useRef([]);
  const [scrollIndex, setScrollIndex] = useState(0);
  const [visibleSections, setVisibleSections] = useState({});

  const images = [
    {
      src: tentang2,
      title: 'Tentang BYD',
      description: `Didirikan pada November 1994, BYD adalah perusahaan teknologi tinggi yang berdedikasi untuk memanfaatkan inovasi teknologi demi kehidupan yang lebih baik. Setelah lebih dari 29 tahun pertumbuhan pesat, BYD telah memainkan peran penting dalam industri terkait elektronik, otomotif, energi terbarukan, dan transit kereta api. Dengan fokus pada akuisisi, penyimpanan, dan aplikasi energi, BYD menawarkan solusi energi baru tanpa emisi yang komprehensif. Sebagai perusahaan yang terdaftar di Bursa Efek Hong Kong dan Bursa Efek Shenzhen, pendapatan tahunan BYD pada tahun 2023 melebihi RMB 602 miliar atau setara dengan IDR 1.361 triliun.`,
    },
    {
      src: tentang3,
      title: 'GLOBALISASI',
      description: `400+ kota, 80+ negara, 6 benua`,
    },
    {
      src: tentang4,
      title: 'Otomotif',
      description: `BYD telah mengembangkan Blade Battery yang terkemuka di industri dan teknologi tenaga hibrida dual-mode, mempercepat transisi sekali dalam seabad dari kendaraan berbahan bakar fosil ke kendaraan listrik.`,
    },
    {
      src: tentang5,
      title: 'Blade Battery',
      specs: [
        {
          value: 'Keamanan Ultra Tinggi',
          label:
            'Blade Battery adalah satu-satunya baterai tenaga yang berhasil melewati uji penetrasi paku dengan aman.',
        },
        {
          value: 'Kekuatan Ultra Hebat',
          label:
            'Kekuatan tekan dapat mencapai 445 kN, yang setara dengan truk sebesar 45 ton',
        },
        {
          value: 'Jarak Tempuh Ultra Panjang',
          label:
            'Blade Battery memungkinkan BYD Han EV memiliki kapasitas jangkauan 600 km, yang akan diperpanjang menjadi 700-800 km di masa depan.',
        },
        {
          value: 'Kemampuan Pengisian Ultra Cepat',
          label:
            'Hanya membutuhkan waktu 33 menit untuk mengisi daya baterai dari 10% hingga 80%, dengan daya lepas muatan maksimum seketika sebesar 363 kW.',
        },
      ],
    },
    {
      src: tentang6,
      title: 'DM-i Konsumsi Bahan Bakar Sangat Rendah',
      specs: [
        {
          value: 'Cepat',
          label:
            '2~3 detik lebih cepat dibandingkan dengan kendaraan mesin pembakaran penuh dari kelas yang sama dalam hal akselerasi 0-100 km/jam',
        },
        {
          value: 'Ekonomis',
          label:
            'Konsumsi bahan bakar dengan kehilangan daya serendah 3,8L/100 km',
        },
        { value: 'Tenang', label: 'Tenang, seperti kendaraan listrik (EV)' },
        { value: 'Halus', label: 'Kontrol elektronik, sangat halus' },
      ],
    },
    {
      src: tentang7,
      title: 'Tenaga Super DM-p',
      description: `Akselerasi 0-100 km/jam dalam 4,5 detik`,
    },
    {
      src: tentang8,
      title: 'e-platform 3.0',
      specs: [
        {
          value: 'Keamanan',
          label:
            'Dilengkapi dengan baterai Blade ultra-aman yang diintegrasikan ke dalam bodi mobil, platform e 3.0 membangun struktur rangka kendaraan listrik murni khusus untuk meningkatkan kekakuan kendaraan.',
        },
        {
          value: 'Efisiensi Tinggi',
          label:
            'Ini memungkinkan jangkauan lebih dari 620 mil dengan sekali pengisian melalui powertrain listrik 8-in-1 pertama di dunia. Konsumsi energi per 100 km kendaraan dengan platform e 3.0 10% lebih rendah dibandingkan dengan model kelas yang sama.',
        },
        {
          value: 'Kecerdasan',
          label:
            'Kontroler domain dan BYD OS (Sistem Operasi) memfasilitasi tingkat tinggi dari pengemudi cerdas. Pemisahan perangkat keras dan perangkat lunak mencapai evolusi mandiri konstan dari seluruh kendaraan.',
        },
        {
          value: 'Estetika',
          label:
            'Kendaraan ini memiliki overhang yang lebih pendek dan wheelbase yang lebih panjang, secara signifikan memperluas ruang penumpang; bodi yang lebih rendah dan wheelbase yang lebih panjang membebaskan desain aerodinamis kendaraan, mengurangi koefisien drag menjadi 0,21Cd.',
        },
      ],
    },
    {
      src: tentang9,
      title: 'Sistem Kokpit Cerdas BYD',
      description: `Semua fungsi smartphone terintegrasi ke dalam platform di dalam kendaraan.`,
    },
    {
      src: tentang10,
      title: 'Kinerja Pasar',
      description: `BYD mengakhiri tahun 2023 dengan lebih dari 3,02 juta unit kendaraan energi baru (NEV) terjual, dengan volume ekspor melebihi 240 ribu unit, dan menduduki peringkat 10 besar penjualan mobil baru global pada paruh pertama tahun ini. Pada tanggal 4 Juli 2024, BYD menjadi produsen mobil pertama di dunia yang memproduksi kendaraan energi baru ke-8 juta.`,
    },
    {
      src: tentang11,
      title: 'Pengurangan Polusi dan Emisi',
      description:
        'Per tanggal 11 November 2023, BYD telah menghemat 44,421,726,348 kg emisi karbon, setara dengan menanam sekitar 740,362,106 pohon.',
    },
  ];

  const handleScroll = useCallback(
    (e) => {
      e.preventDefault();
      const delta = e.deltaY;

      if (delta > 0 && scrollIndex < images.length - 1) {
        setScrollIndex((prev) => prev + 1);
      } else if (delta < 0 && scrollIndex > 0) {
        setScrollIndex((prev) => prev - 1);
      }
    },
    [scrollIndex, images.length]
  );

  useEffect(() => {
    const currentSections = sections.current;
    const observer = new IntersectionObserver(
      (entries) => {
        const updatedVisibleSections = { ...visibleSections };
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            updatedVisibleSections[entry.target.dataset.index] = true;
          }
        });
        setVisibleSections(updatedVisibleSections);
      },
      { threshold: 0.5 }
    );

    currentSections.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      currentSections.forEach((section) => {
        if (section) observer.unobserve(section);
      });
    };
  }, [visibleSections]);

  useEffect(() => {
    window.addEventListener('wheel', handleScroll, { passive: false });
    return () => {
      window.removeEventListener('wheel', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    sections.current[scrollIndex]?.scrollIntoView({ behavior: 'smooth' });
  }, [scrollIndex]);

  return (
    <Box>
      <Helmet>
        <title>Tentang BYD | Mobil Listrik Terpercaya di Indonesia</title>
        <meta
          name='description'
          content='Pelajari sejarah, teknologi Blade Battery, dan e-Platform 3.0 dari BYD. Jelajahi keunggulan mobil listrik BYD seperti BYD M6, Dolphin, dan Sealion 7 di BSD Serpong.'
        />
        <meta
          name='keywords'
          content='Tentang BYD, BYD BSD Serpong, Mobil Listrik Indonesia, Blade Battery, e-Platform 3.0, Mobil Listrik Aman'
        />
        <link rel='canonical' href='https:/bydbsdserpong/about-byd' />
      </Helmet>
      <Typography
        variant='h1'
        component='h1'
        sx={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          zIndex: 10,
          color: '#fff',
          fontSize: { xs: '1.5rem', sm: '2.5rem' },
          fontWeight: 'bold',
        }}
      >
        Dealer Mobil Listrik BYD BSD Serpong
      </Typography>

      {images.map((img, index) => (
        <Box
          key={index}
          ref={(el) => (sections.current[index] = el)}
          data-index={index}
          sx={{
            position: 'relative',
            height: '100vh',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          <Box
            component='img'
            src={img.src}
            alt={`Image ${index + 1}`}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: -1,
            }}
          />

          {img.title && (
            <Box
              sx={{
                position: 'absolute',
                top: { xs: '10%', sm: '15%' },
                color: '#fff', // Black for atto4 and atto7
                textAlign: 'center',
                padding: 2,
                transform: visibleSections[index]
                  ? 'translateY(0)'
                  : 'translateY(100%)',
                opacity: visibleSections[index] ? 1 : 0,
                transition: 'all 0.8s ease-in-out',
              }}
            >
              <Typography
                variant='h4'
                fontWeight='bold'
                sx={{
                  fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                }}
              >
                {img.title}
              </Typography>
            </Box>
          )}

          {img.specs && (
            <Box
              sx={{
                position: 'absolute',
                bottom: { xs: '10%', sm: '5%' },
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'center',
                gap: { xs: 2, sm: 4 },
                color: '#fff',
              }}
            >
              {img.specs.map((spec, i) => (
                <React.Fragment key={i}>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography
                      variant='h6'
                      fontWeight='bold'
                      sx={{
                        fontSize: { xs: '1rem', sm: '1.25rem' },
                      }}
                    >
                      {spec.value}
                    </Typography>
                    <Typography
                      variant='body2'
                      sx={{
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                      }}
                    >
                      {spec.label}
                    </Typography>
                  </Box>
                </React.Fragment>
              ))}
            </Box>
          )}

          {img.description && (
            <Box
              sx={{
                position: 'absolute',
                bottom: { xs: '15%', sm: '10%' },
                color: '#fff',
                textAlign: 'center',
                padding: 2,
                maxWidth: { xs: '90%', sm: '80%' },
                background: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '8px',
                transform: visibleSections[index]
                  ? 'translateY(0)'
                  : 'translateY(100%)',
                opacity: visibleSections[index] ? 1 : 0,
                transition: 'all 0.8s ease-in-out',
              }}
            >
              <Typography
                variant='body1'
                fontWeight='400'
                lineHeight='1.5'
                sx={{
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                }}
              >
                {img.description}
              </Typography>
            </Box>
          )}
        </Box>
      ))}
      <Box sx={{ p: 4, backgroundColor: '#f9f9f9', textAlign: 'center' }}>
        <Typography variant='h5' fontWeight='bold' mb={2}>
          🚗 Ingin Tahu Harga Mobil Listrik BYD?
        </Typography>
        <Typography variant='body1' mb={3}>
          Cek informasi lengkap tentang <strong>Harga BYD M6</strong>,{' '}
          <strong>Harga Denza D9</strong>, <strong>Harga Sealion 7</strong>, dan{' '}
          <strong>Harga Atto1</strong> di halaman pricing kami.
        </Typography>
        <Button variant='contained' color='primary' href='/pricing'>
          Lihat Harga Mobil BYD
        </Button>
      </Box>
    </Box>
  );
}

export default TentangBYD;
